import { render, staticRenderFns } from "./handleFreeze.vue?vue&type=template&id=4ceb83fc&"
import script from "./handleFreeze.vue?vue&type=script&lang=js&"
export * from "./handleFreeze.vue?vue&type=script&lang=js&"
import style0 from "./handleFreeze.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "handleFreeze.vue"
export default component.exports